import Vue from 'vue';
import Router from 'vue-router';
// vistas
import Home from './views/Home.vue';
import Productos from './views/Productos.vue';
import Empresa from './views/Empresa.vue';
import Recetas from './views/Recetas.vue';
// marcas
import Mayra from './views/marcas/Mayra.vue';
import Outlandish from './views/marcas/Outlandish.vue';
import Modernman from './views/marcas/Modernman.vue';
import Maynekman from './views/marcas/Maynekman.vue';
// detalle frutas
import DetalleCereza from './views/frutas/cereza.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/productos',
      name: 'productos',
      component: Productos,
    },
    {
      path: '/empresa',
      name: 'empresa',
      component: Empresa,
    },
    {
      path: '/recetas',
      name: 'recetas',
      component: Recetas,
    },
    {
      path: '/mayra',
      name: 'frutas mayra',
      component: Mayra,
    },
    {
      path: '/outlandish',
      name: 'Outlandish',
      component: Outlandish,
    },
    {
      path: '/modernman',
      name: 'Modernman',
      component: Modernman,
    },
    {
      path: '/maynekman',
      name: 'Maynekman',
      component: Maynekman,
    },
    {
      path: '/contacto',
      name: 'contacto',
      component: () => import('@/views/Contacto.vue'),
    },
    {
      path: '/cereza',
      name: 'Cereza',
      component: DetalleCereza,
    },

    // {
    //   path: '/fresa',
    //   name: 'Fresa',
    //   component: () => import('@/views/frutas/fresa.vue'),
    // },
    {
      path: '/durazno',
      name: 'Durazno',
      component: () => import('@/views/frutas/durazno.vue'),
    },
    {
      path: '/aguacate',
      name: 'Aguacate',
      component: () => import('@/views/frutas/aguacate.vue'),
    },
    {
      path: '/berries',
      name: 'Berries',
      component: () => import('@/views/frutas/berries.vue'),
    },
    {
      path: '/ciruela',
      name: 'Ciruela',
      component: () => import('@/views/frutas/ciruela.vue'),
    },
    {
      path: '/higo',
      name: 'Higo',
      component: () => import('@/views/frutas/higo.vue'),
    },
    {
      path: '/fresa',
      name: 'Fresa',
      component: () => import('@/views/frutas/fresa.vue'),
    },
    {
      path: '/litchi',
      name: 'Litchi',
      component: () => import('@/views/frutas/litchi.vue'),
    },
    {
      path: '/mandarina',
      name: 'Mandarina',
      component: () => import('@/views/frutas/mandarina.vue'),
    },
    {
      path: '/mango',
      name: 'Mango',
      component: () => import('@/views/frutas/mango.vue'),
    },
    {
      path: '/manzana',
      name: 'Manzana',
      component: () => import('@/views/frutas/manzana.vue'),
    },
    {
      path: '/melon',
      name: 'Melon',
      component: () => import('@/views/frutas/melon.vue'),
    },
    {
      path: '/nectarina',
      name: 'Nectarina',
      component: () => import('@/views/frutas/nectarina.vue'),
    },
    {
      path: '/pera',
      name: 'Pera',
      component: () => import('@/views/frutas/pera.vue'),
    },
    {
      path: '/peraAsiatica',
      name: 'Pera Asiatica',
      component: () => import('@/views/frutas/peraAsiatica.vue'),
    },
    {
      path: '/uva',
      name: 'Uva',
      component: () => import('@/views/frutas/uva.vue'),
    },
    {
      path: '/bebidaNectarina',
      name: 'Bebida de Nectarina',
      component: () => import('@/views/recetas/bebidaNectarina.vue'),
    },
    {
      path: '/ensalada',
      name: 'Ensalda',
      component: () => import('@/views/recetas/ensalada.vue'),
    },
    {
      path: '/ensaladaMelon',
      name: 'Ensalada de Melon',
      component: () => import('@/views/recetas/ensaldaMelon.vue'),
    },
    {
      path: '/fresasChocolate',
      name: 'fresasChocolate',
      component: () => import('@/views/recetas/fresasChocolate.vue'),
    },
    {
      path: '/smoothie',
      name: 'smoothie',
      component: () => import('@/views/recetas/smoothie.vue'),
    },
    {
      path: '/volovanesFrutas',
      name: 'volovanesFrutas',
      component: () => import('@/views/recetas/volovanesFrutas.vue'),
    },
    {
      path: '/merengueFresas',
      name: 'merengueFresas',
      component: () => import('@/views/recetas/merengueFresas.vue'),
    },
    {
      path: '/tortaCiruelas',
      name: 'tortaCiruelas',
      component: () => import('@/views/recetas/tortaCiruelas.vue'),
    },
    {
      path: '/smoothieManzana',
      name: 'smoothieManzana',
      component: () => import('@/views/recetas/smoothieManzana.vue'),
    },
    {
      path: '/puddingMango',
      name: 'puddingMango',
      component: () => import('@/views/recetas/puddingMango.vue'),
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});
